import { AppRouteRecordRaw } from '../types';

const FleetCheckoutPage = () => import('@/pages/checkout/fleet/FleetCheckoutPage.vue');

/**
 * Public fleet checkout (D-01, R-01).
 *
 * Rendered for anonymous visitors, outside the dashboard `Body` shell. The
 * `/checkout/` prefix is allow-listed in the global auth guard through
 * `isPublicPath()` (src/utils/publicRoutes.ts), skipped by the Firebase
 * Analytics bootstrap, and treated like `/promo/` by the Consent Mode block in
 * index.html. Website CTAs deep-link here with `plan`, `term`, `utm_*` and the
 * optional calculator values; unknown parameters are ignored, never redirected.
 *
 * Deliberately NO `meta.requiredRoles`/`requiredUserGroup`/etc. — any of those
 * would flip `requiresAuthCheck` on and dereference a null `userAddData`.
 */
export const checkoutRoutes: AppRouteRecordRaw[] = [
  {
    path: '/checkout/fleet',
    name: 'fleetCheckout',
    component: FleetCheckoutPage,
    meta: {
      title: 'ryd fleet – Konto erstellen',
    },
  },
];
